import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_batch_pool_to_irb_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  batch_pool_hdr_guid : fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid : fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass implements bl_fi_my_einvoice_batch_pool_to_irb_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  batch_pool_hdr_guid : fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid : fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
